import React, { ReactElement } from 'react';
import NumericInput from "./NumericInput";

export type RateInputProps = {
	id: string,
	name?: string,
	label: string,
	required: boolean,
	maxLength?: number,
	labelContent?: ReactElement,
	changeCallback?: Function,
	children?: React.ReactNode,
}

const RateInput = (props: RateInputProps) => {
	return <NumericInput id={props.id} name={props.name} label={props.label} required={props.required} maxLength={props.maxLength}
						 labelContent={props.labelContent}
						 changeCallback={props.changeCallback}
						 inputMask={{ regex: '^\\d*(\\.\\d{1,3})?$', placeholder: '' }}/>
};
export default RateInput;